import React, { Dispatch, SetStateAction, useState } from "react";

import { SearchBar } from "@culturehq/components";

import { AWSLanguage, Subtitle } from "chq";
import { t, Trans } from "app/utils";
import { languages } from "app/utils/aws-languages.json";

import TranscriptionOption from "./TranscriptionOption";

interface TranscriptionContainerProps {
  onSetError: Dispatch<SetStateAction<string | undefined>>;
  onLanguageSelected: (subtitle: Subtitle) => void;
}

const TranscriptionContainer: React.FC<TranscriptionContainerProps> = ({
  onSetError, onLanguageSelected
}) => {
  const [languagesOptions, setLanguagesOptions] = useState<AWSLanguage[]>(
    languages.filter(language => !!language.transcription)
  );

  const handleSearch = (query: string) => {
    if (query) {
      const results = languages.filter(language => !!language.transcription).filter(language => {
        const result = language.transcription?.toLocaleLowerCase()?.search(
          query.toLocaleLowerCase()
        );
        return result !== -1;
      });
      setLanguagesOptions(results);
    } else {
      setLanguagesOptions(languages.filter(language => !!language.transcription));
    }
  };

  return (
    <div>
      <p>
        <Trans>
          Choose the native language that&apos;s in this video to add subtitles.
          After this is processed, you can choose to translate the subtitles
          to any other language.
        </Trans>
      </p>
      <SearchBar
        autoFocus
        onSearch={handleSearch}
        placeholder={t("Search")}
      />
      <ul className="Language-list">
        {languagesOptions.map((language, index) => (
          <TranscriptionOption
            key={index}
            language={language}
            onLanguageSelected={onLanguageSelected}
            onSetError={onSetError}
          />
        ))}
      </ul>
    </div>
  );
};

export default TranscriptionContainer;
